import { FC, memo, useId } from 'react'

import { MapProviderProps } from '../../lib/types'

import { useMap2GIS } from './useMap2GIS'

/**
 * Мемоизированный контейнер для карты
 * FIX: Никогда не ре-рендерится (как в оригинальном MapWrapper)
 */
const MapContainer = memo<{ id: string }>(
  ({ id }) => (
    <div
      id={id}
      style={{
        width: '100%',
        height: '100%',
        position: 'relative',
      }}
    />
  ),
  () => true // Никогда не обновляем контейнер
)

MapContainer.displayName = 'MapContainer'

/**
 * Провайдер карты 2GIS
 * ✅ Использует уникальный ID для каждого экземпляра
 */
export const Map2GISProvider: FC<MapProviderProps> = ({ settings, onReady, onError }) => {
  // FIX: Уникальный ID для каждого экземпляра карты
  const containerId = `map-container-${useId().replace(/:/g, '')}`

  // Инициализируем карту через хук
  useMap2GIS(containerId, settings, onReady, onError)

  return <MapContainer id={containerId} />
}

Map2GISProvider.displayName = 'Map2GISProvider'
